import { styled } from "@monolith-forensics/monolith-ui";
import { MainDetails } from "./MainDetails";
import { File } from "../../files.types";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;

  padding: 10px 0px;
`;

export const FlyoutDetailsTab: React.FC<{
  defaultData: File;
  onChange: () => void;
}> = ({ defaultData, onChange }) => {
  return (
    <StyledContainer>
      <MainDetails defaultData={defaultData} onChange={onChange} />
    </StyledContainer>
  );
};
